export default __webpack_public_path__ + "static/media/num-04.26ea1387.svg";